export default "__VITE_ASSET__0EIfUjv1__"